<template>
  <v-row>
    <v-col class="change_column">
      <v-card class="single_section">
        <div class="font-weight-bold"><slot name="title"></slot></div>
        <div><slot name="content"></slot></div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>

  .change_column {
    padding: 0 13px;
    margin-bottom: 12px;
  }

  .single_section {
    padding: 5px 10px;
  }

</style>
